import { render } from "./ValidationError.vue?vue&type=template&id=539f8f98&scoped=true"
import script from "./ValidationError.js?vue&type=script&lang=js"
export * from "./ValidationError.js?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=539f8f98&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ValidationError.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2Fcomponents%2FBaseInput%2FBaseLabel%2FValidationError%2FValidationError.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539f8f98"]])

export default __exports__